/**
 *
 * @author Matthew Rawson @ 29/03/2018 14:16
 * @description
 * @notes
 *
 */
import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {get} from "lodash"

import id from "@irati/utils/id/index"
import {Checkbox, Label} from "@irati/ui/src/FormItem"
import {injectIntl, getMessage} from "@irati/utils/lang"

import {PROPERTY as TEAM_IDS_PROPERTY} from "./TeamIds"

export const PROPERTY = "preferences.sendToAll"

export const StyledLabel = styled(Label)`
  display: inline;
  padding-left: 10px;
`

class SendToAll extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    name: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    formatMessage: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    name: PROPERTY,
    title: "insights.surveys.manage.sendToAllTitle",
    label: "insights.surveys.manage.sendToAllLabel",
    disabled: false
  }

  handleChange = () => {
    const {onChange, schedule, name} = this.props
    const changes = {
      [TEAM_IDS_PROPERTY]: [],
      [name]: !get(schedule, name)
    }
    onChange(null, changes)
  }

  render() {
    const idNamespace = id("SendToAll", this.props)
    const {schedule, name, label, title, disabled} = this.props

    return (
      <Fragment>
        <Label>{getMessage(this, title)}</Label>
        <Checkbox disabled={disabled} id={idNamespace} name={name} checked={get(schedule, name)} onChange={this.handleChange}>
          {getMessage(this, label)}
        </Checkbox>
      </Fragment>
    )
  }
}

export default injectIntl(SendToAll)
